<template>
  <v-card class="mx-auto cardstep" min-height="400"  >
    <div class="d-flex justify-center" >
        <video playsinline autoplay muted loop v-if="hasVideo" :class="videostep" @click.capture="zoomviewtext(true)">
          <source v-if="imageurlItem" :src="imageurlItem" :key="componentKey" type="video/mp4">
              Your browser does not support the video tag.
          <track kind="captions" label="French" :src="subtitleBlobfr"  srclang="fr" default v-if="language == 'fr'"/>
          <track kind="captions" label="English" :src="subtitleBloben"  srclang="en" default v-else/>
        </video>
        <v-img
          v-else-if="item.image"
          :class="imagestep"
          contain
          lazy-src="@/assets/imagenotfound.png"
          :key="getItemImageKey(item)"
          :src="getImageUrlByObject(item)"
          @click="zoomviewtext(true)"
        >
        </v-img>
         
      </div>
      <v-card-subtitle class="pb-0">
        
      </v-card-subtitle>

      <v-card-text :class="textstep">
          <v-btn
              v-if="this.isZoom && this.item.image"
              class="ma-1 btn_step"
              color="#1E1E1E"
              fab
              elevation="0"
              x-small
              absolute
              top
              @click="zoomviewtext(false)"
            >
              <v-icon>mdi-chevron-down</v-icon>
          </v-btn> 
        <v-row class="d-flex align-end cardtext">
          <v-col cols="10" sm="10" md="11">
            <div class="">
              <span class="text-h5 primary--text" >
                <span v-if="language == 'fr'">{{ item.namefr }}</span>
                <span v-else>{{ item.name }}</span>
              </span>
              <p class="">
                <span class="tablehtmleditor" v-if="language == 'fr'" v-html="item.descriptionfr"></span>
                <span class="tablehtmleditor" v-else v-html="item.description"></span>
              </p>
            </div>
            <div class="" v-if="! this.isZoom">
            <v-btn
              v-if="userHasAccess('step_edit')"
              class="ma-1"
              color="primary"
              small
              @click="editStep"
            >
              {{ $t('global.update')}}
            </v-btn>
          </div>
          </v-col>
          <v-col cols="2" sm="2" md="1">
            <div class="d-flex justify-end align-end divzoom"  >
              <v-btn
              class="ma-1"
              icon
              large
              @click="zoom"
            >
              <v-icon v-if="this.isZoom">mdi-fullscreen-exit</v-icon>
              <v-icon v-else>mdi-fullscreen</v-icon>
            </v-btn> 
          </div>
         </v-col>
        </v-row>


      </v-card-text>

      <v-btn
          class="ma-2 mt-12"
          fab
          dark
          small
          absolute
          top
          left
          color="primary"
          @click="viewStep"
        >
        <strong class="text-h6 font-weight-black">{{ item.number }}</strong>
      </v-btn>

      <div class="optionstep">
        <v-avatar color="accent" size="25" class="ma-2" v-if="item.action">
          <v-icon small color="white">
            mdi-file-code
          </v-icon>
        </v-avatar>
        <v-avatar color="accent" size="25" class="ma-2" v-if="item.moduleRef">
          <v-icon small color="white">
            mdi-toolbox
          </v-icon>
        </v-avatar>
        <v-avatar color="accent" size="25" class="ma-2" v-if="item.validator">
          <v-icon small color="white">
            mdi-bookmark-check
          </v-icon>
        </v-avatar>
        <v-avatar color="accent" size="25" class="ma-2" v-if="item.tempProgress">
          <v-icon small color="white">
            mdi-thermometer-lines
          </v-icon>
        </v-avatar>
        <v-avatar color="accent" size="25" class="ma-2" v-if="item.movementPanel">
          <v-icon small color="white">
            mdi-arrow-all
          </v-icon>
        </v-avatar>
        <v-avatar color="accent" size="25" class="ma-2" v-if="item.logPanel">
          <v-icon small color="white">
            mdi-note-text
          </v-icon>
        </v-avatar>        
      </div>
    </v-card>

</template>

<script>
import i18n from '../../i18n.js';
import FileMixin from '../../mixins/FileMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'StepCard',
  props: {
    values: {
      type: Object,
      required: true
    },
    process: {
      type: Object,
      required: true
    },
    isZoom: {
      type: Boolean,
      required: true
    },
    zoom: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      zoomviewtextData: true,
    };
  },
  mounted() {
  },
  mixins: [FileMixin,AccessMixin],
  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    language() {
      return i18n.locale;
    },
    filter() {
      if (this.hasVideo) {
        return "";
      } else {
        //return '400x400';
        return '';
      }
    },
    subtitleBlobfr() {
      var data = new Blob([this.item['subtitlefr']], {type: 'text/plain'});
      return URL.createObjectURL(data);
    },
    subtitleBloben() {
      var data = new Blob([this.item['subtitle']], {type: 'text/plain'});
      return URL.createObjectURL(data);
    },
    videostep() {
      if (this.isZoom) {
        return 'video_step_fullscreen';
      } else {
        return 'video_step';
      }
    },
    imagestep() {
      if (this.isZoom) {
        return 'ma-2 image_step_fullscreen';
      } else {
        return 'ma-2 image_step';
      }
    },
    textstep() {
      if (this.isZoom) {
        if(this.zoomviewtextData) {
          return 'text_step_fullscreen';
        } else {
          return 'text_step_fullscreen_reduce';
        }
        
      } else {
        if(this.item.image) {
          return '';
        } else {
          return 'cardtext';
        }
        
      }
    },
    isZoomviewtext() {
      return this.zoomviewtextData;
    },
  },
  methods: {

    viewStep() {
       this.$router.push({ name: `StepShow` , params: { parent: this.process['@id'], id: this.item['@id'] }});
    },
    editStep() {
       this.$router.push({ name: `StepUpdate` , params: { parent: this.process['@id'], id: this.item['@id'] }});
    },
    zoomviewtext(value) {
      
      if(value) {
        this.zoomviewtextData = true;
      } else {
        if (this.item.image) {
          this.zoomviewtextData = false;
        }
        
      }
      
    }

  }
};
</script>
<style>

video {
  max-width: 100%;
  height: 80%;
}
.video_step_fullscreen {
  height: 100%; 
  width: 100%;
}
.image_step_fullscreen {
  height: 100%; 
  width: 100%;
}
.text_step_fullscreen {
  position: absolute;
  bottom: 0px;
  background-color: rgba(30, 30, 30, 0.8);

}
.text_step_fullscreen_reduce {
  display: none;
}
.btn_step {
  left: 50%;
}
@media screen and (max-height: 1200px) {
  .video_step {
    max-height: 800px; 
    min-height: 700px;
  }
  .image_step {
    max-height: 800px; 
    min-height: 700px;
  }
}
@media screen and (max-height: 1000px) {
  .video_step {
    max-height: 600px; 
    min-height: 500px;
  }
  .image_step {
    max-height: 600px; 
    min-height: 500px;
  }
}
@media screen and (max-height: 800px) {
  .video_step {
    max-height: 400px; 
    min-height: 300px;
  }
  .image_step {
    max-height: 300px; 
    min-height: 300px;
  }
}
@media screen and (max-height: 600px) {
  .video_step {
    max-height: 200px; 
  }
  .image_step {
    max-height: 200px; 
  }
}
@media screen and (max-height: 400px) {
  .video_step {
    max-height: 100px; 
  }
  .image_step {
    max-height: 100px; 
  }
}
.optionstep {
  position: absolute;
  top: 0px;
  right: 0px;
}

#carouselStep:-webkit-full-screen  {
  width: 100%;
  height: 100%;
}

.divzoom {
  height:100%;
}
.cardstep {
  height:100%;
}
.cardtext {
  height:100%;
}
</style>